<template>
    <button
        class="absolute top-0 left-0 mt-4 ml-4 flex items-center"
        :title="$config('BACK')"
        @click="goBack"
    >
        <font-awesome-icon
            icon="arrow-circle-left"
            class="text-2xl text-blue"
        />

        <span v-if="withText" class="font-primary ml-2 text-lg">{{
            $config("BACK")
        }}</span>
    </button>
</template>

<script>
export default {
    name: "back-button",

    props: {
        withText: {
            type: Boolean,
            default: false
        }
    },

    methods: {
        goBack() {
            this.$router.go(-1);
        }
    }
};
</script>
